import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Row, Col } from 'reactstrap'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import 'chartjs-plugin-zoom'
import 'chartjs-plugin-annotation'

import {getStructureById} from '../../modules/structures'
import APIRequest from '../../helpers/APIRequest'

import LoadingIcon from 'react-icons/lib/fa/spinner'

// import Loading from 'react-icons/lib/fa/circle-o-notch'
// import CheckIcon from 'react-icons/lib/fa/check'

// import DownloadIcon from 'react-icons/lib/fa/download'

// const brandPrimary = '#20a8d8';
// const brandSuccess = '#4dbd74';
// const brandInfo = '#63c2de';
// const brandWarning = '#f8cb00';
// const brandDanger = '#f86c6b';
//
// const colors = [brandSuccess, brandWarning, brandDanger, brandInfo, brandPrimary]

const getFormula = (formula = '') => {
  return <span dangerouslySetInnerHTML={{__html: formula.replace(/\d+(\.\d+)?/g,'<sub>$&</sub>')}}/>
}

class Structure extends Component {

  componentWillMount() {
    if (this.props) {
      const getStructureById = this.props.getStructureById;
      getStructureById(this.props.structureId);
      this.interval = setInterval(function() {
        if (this.props && this.props.structure) {
          getStructureById(this.props.structureId);
        }
      }.bind(this), 10000);
    }
  }

  componentDidUpdate(prevProps) {
    // const that = this;
    const structure = this.props.structure;
      if (structure && this.jmolDiv && this.jmolId !== structure._id) {
        // const div = document.getElementById('appletplace1');
        this.jmolId = structure._id;
        this.getStructureCif();
      }

    }

  componentWillUnmount() {

    const div = document.getElementById('appletplace1');
    const hideJmol = document.getElementById('hideJmol');
    hideJmol.appendChild(div);
  }

  getStructureCif() {
    const div = document.getElementById('appletplace1');
    const structure = this.props.structure;
    APIRequest.get(`structures/${this.props.structure.relaxedStructure._id}/cif`, {responseType: 'blob'}).then(res => {
      this.jmolDiv.appendChild(div);
      const reader = new FileReader();
      reader.onloadend = function(evt) {
        if (evt.target.readyState === FileReader.DONE) {
          window.fileName = `${structure.name}.cif`;
          window.buffer = evt.target.result;
          document.getElementById('loadCif').click()
          //Jmol._setData(null, `${structure.name}.cif`, `${structure.name}.cif`, evt.target.result, null, myJmol);
        }
      };
      try {
        reader.readAsArrayBuffer(res.data);
      } catch (e) {
        alert("You must select a file first.");
      }
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  getSupercellCif(vector) {
    const div = document.getElementById('appletplace1');
    const structure = this.props.structure;
    APIRequest.get(`structures/${this.props.structure.relaxedStructure._id}/supercellCif?vector=${vector}`, {responseType: 'blob'}).then(res => {
      this.jmolDiv.appendChild(div);
      const reader = new FileReader();
      reader.onloadend = function(evt) {
        if (evt.target.readyState === FileReader.DONE) {
          window.fileName = `${structure.name}.cif`;
          window.buffer = evt.target.result;
          document.getElementById('loadCif').click()
          //Jmol._setData(null, `${structure.name}.cif`, `${structure.name}.cif`, evt.target.result, null, myJmol);
        }
      };
      try {
        reader.readAsArrayBuffer(res.data);
      } catch (e) {
        alert("You must select a file first.");
      }
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  render() {
    const structure = this.props.structure || [];
    const project = this.props.project || [];
    if (structure) {
      return (
        <div>
          <ol className="breadcrumb bg-gray-600 border-bottom-0 align-items-center">
            <li className="breadcrumb-item">
              <Link to="/projects">Projects</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/projects/${project._id}`}>{getFormula(project.name)}</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/projects/${project._id}`}>structures</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/projects/${project._id}/structures/${structure._id}`}>{structure.name}</Link>
            </li>
            <li className="breadcrumb-item active">QCats Viewer</li>

          </ol>

          <div className="card m-3">
            <div className="card-body">
              <Row>
                <Col className="col-auto mr-auto"><h1 className="card-title text-dark">{getFormula(structure.name)}</h1></Col>
                <Col className="col-auto">
                  {/*<select className="custom-select" onChange={this.getSupercellCif.bind(this)}>
                    <option value="[1,1,1]">1x1x1</option>
                    <option value="[2,2,2]">2x2x2</option>
                    <option value="[1,2,3]">1x2x3</option>
                  </select>&nbsp;*/}
                  <Link className="btn btn-secondary" to={`/projects/${project._id}/structures/${structure._id}`}>X</Link>
                </Col>
              </Row>
              <div ref={(jmolDiv) => { this.jmolDiv = jmolDiv; }} style={{display: 'flex', position: 'relative', height: '40rem', width: '100%'}}>
                <LoadingIcon className="fa-spin m-auto text-gray-200" size="512"/>
              </div>

            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  structure: state.structures.byId[ownProps.match.params.structureId],
  project: state.projects.byId[ownProps.match.params.projectId],
  structureId: ownProps.match.params.structureId
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getStructureById
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Structure))



// WEBPACK FOOTER //
// ./src/containers/structures/jmol.js